<article [routerLink]="detailLink" class="tfr-explore-card">

  <div class="relative h-44 w-full shrink-0 overflow-hidden bg-pale-gray">
    @if (coverImage) {
      <img
        [ngSrc]="coverImage"
        [alt]="space.name"
        fill
        class="object-cover"
        [sizes]="cardImageSizes" />
    } @else {
      <div class="h-full w-full flex items-center justify-center bg-gradient-to-br from-pale-gray to-platinum-tint">
        <svg class="h-10 w-10 text-steel-gray" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.25">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
      </div>
    }
  </div>

  <div class="flex flex-col flex-1 p-5">
    <h2 class="text-[16px] font-bold leading-[1.3] text-midnight-indigo mb-1 line-clamp-1">{{ space.name }}</h2>
    @if ((space.reviewCount ?? 0) > 0 && space.averageRating !== null) {
      <p class="mb-1 flex items-center gap-1 text-[12px] font-semibold text-midnight-indigo">
        <svg class="h-3.5 w-3.5 text-amber-500 fill-amber-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" stroke-width="0">
          <path fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <span class="tabular-nums">{{ space.averageRating | number:'1.1-1' }}</span>
        <span class="font-normal text-steel-gray">({{ space.reviewCount }})</span>
      </p>
    }
    <p class="text-[13px] text-slate-blue mb-4 line-clamp-1 flex items-center gap-1.5">
      <svg class="h-3.5 w-3.5 shrink-0 text-steel-gray" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
      </svg>
      {{ locationLabel }}
    </p>
    <div class="flex items-center gap-3 mt-auto pt-3 border-t border-pale-gray">
      <span class="flex items-baseline gap-1.5 text-action-blue">
        <span class="text-[11px] font-semibold text-slate-blue">Desde</span>
        <span class="text-[15px] font-bold tabular-nums">{{ fromHourlyRate }}&euro;/h</span>
      </span>
      <span class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-pale-gray text-slate-blue ml-auto">
        <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>
        {{ space.capacity }} pers.
      </span>
    </div>
  </div>
</article>
